import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../../hooks/useAuth";
import { ROUTES } from "../../constants/routes";

/**
 * A wrapper for routes that should ONLY be accessible to unauthenticated users
 * (e.g., SignIn, SignUp, ForgotPassword).
 * If the user IS authenticated, they are redirected to the dashboard.
 */
const PublicRoute = ({ children }) => {
  const { isAuthenticated } = useAuth();

  if (isAuthenticated()) {
    // Redirect to dashboard if they are already logged in
    return <Navigate to={ROUTES.DASHBOARD} replace />;
  }

  return children;
};

export default PublicRoute;
